<script lang="ts">
	import BoxHighlightContent from '$lib/components/boxes/variants/BoxHighlightContent.svelte';
	import type { HighlightBlueProps } from './types';

	export let props: HighlightBlueProps;
</script>

{#if props}
	<BoxHighlightContent
		props={{
			content: props.text,
			ctaLabel: props.cta[0].label ?? undefined,
			cta: props.cta[0].link
				? props.cta[0].link.url || `/${props.cta[0].link.cached_url}`
				: undefined,
			targetBlank: props.cta[0].target_blank ?? undefined
		}}
	/>
{/if}
